/*
 * List of root reducers to be combined
 */

import session from './session';
import data from './data';
import themeReducer from 'containers/providers/ThemeProvider/reducer';

import propertyReducerByDay from 'legacy/main/reducers/dayViewReducer';
import apiErrorReducer from 'legacy/main/reducers/apiErrorReducer';
import dashBoardReducer from 'legacy/main/reducers/dashBoardReducer';
import propertyReducerByYear from 'legacy/main/reducers/yearViewReducer';
import propertyReducerByMonth from 'legacy/main/reducers/monthViewReducer';
import recommendationReducer from 'legacy/main/reducers/recommendationReducer';

export default {
    session: session.reducer,
    theme: themeReducer,
    data: data.reducer,
    // Legacy reducers
    yearData: propertyReducerByYear,
    monthData: propertyReducerByMonth,
    dayData: propertyReducerByDay,
    recommendations: recommendationReducer,
    dashBoard: dashBoardReducer,
    apiError: apiErrorReducer,
};
